module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ja":{"title":"今月のこり {days}日","daily":"今日までの目標達成率:","monthly":"今月の目標達成率:","target":"目標達成率","achieved":"実績","remaining":"残り","target_tooltip":"月初から今日までの売上目標の達成度、月間売上目標の達成度を表します。","unit":"円"}}')
  delete Component.options._Ctor
}
